import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { local } from '../storage';
import { AuthAPI } from './auth/service';
import { ChapterAPI } from './chapter/service';
import { ExamAPI } from './exam/service';
import { ExamResolutionAPI } from './examResolution/service';
import { HandoutAPI } from './handout/service';
import { HandoutResolutionAPI } from './handoutResolution/service';
import { LessonAPI } from './lesson/service';
import { LongExamAPI } from './longExam/service';
import { LongExamResolutionAPI } from './longExamResolution/service';
import { MeApi } from './me/service';
import { TutoringAPI } from './tutoring/service';
import { ExtraClassAPI } from './extraClasses/service';
import { ExtraContentAPI } from './extraContent/service'



const axiosInstance = axios.create({
  // baseURL: 'http://localhost:3333',
  // baseURL: 'https://e8c56f7f-874a-4961-b9a4-c460269afcb3.mock.pstmn.io/'
  baseURL: 'https://www.cursobrunomachado.com.br'
});

axiosInstance.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    const user = local.get('user');
    config.baseURL += '/api/v1/';
    if (config.headers) {
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.headers['Content-Type'] = 'application/json';
      if (user && user.access)
        config.headers['Authorization'] = `Bearer ${user.access}`;
    }

    return config;
  }
);

axiosInstance.interceptors.response.use(
  (Response: AxiosResponse) => {
    return Response.data;
  }, (error: any) => {
    return Promise.reject(error.response);
  }
);

export const api = {
  auth: new AuthAPI(axiosInstance),
  chapter: new ChapterAPI(axiosInstance),
  lesson: new LessonAPI(axiosInstance),
  exam: new ExamAPI(axiosInstance),
  tutoring: new TutoringAPI(axiosInstance),
  handout: new HandoutAPI(axiosInstance),
  me: new MeApi(axiosInstance),
  examResolution: new ExamResolutionAPI(axiosInstance),
  handoutResolution: new HandoutResolutionAPI(axiosInstance),
  longExam: new LongExamAPI(axiosInstance),
  longExamResolution: new LongExamResolutionAPI(axiosInstance),
  extraClass: new ExtraClassAPI(axiosInstance),
  extraContent: new ExtraContentAPI(axiosInstance),
}


export const axiosInstancePdf = axios.create({
  baseURL: '/',
});
